import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./globals.css";
import { AuthProvider } from "./core/auth/contexts/AuthContext.tsx";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router-dom";
import routes from "./routes.tsx";
import { ThemeProvider } from "./components/theme-provider.tsx";
import ErrorBoundaryWrapper from "./shared/components/error-boundary.tsx";
import { HelmetProvider } from "react-helmet-async";

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 60000 } },
});
createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorBoundaryWrapper>
      <ThemeProvider defaultTheme="dark" storageKey="vite-ui-theme">
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <div className="font-ubuntu">
              <HelmetProvider>
                <RouterProvider router={routes} />
              </HelmetProvider>
            </div>
          </AuthProvider>
        </QueryClientProvider>
      </ThemeProvider>
    </ErrorBoundaryWrapper>
  </StrictMode>
);
